import './StocksDetails.scss';

import cn from 'classnames';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import ListSort from '@/ebat/components/blocks/ListSort/ListSort';
import SortOptions from '@/ebat/constants/sort';

// eslint-disable-next-line import/no-cycle
import Item from './Item/Item';
import {
  StocksDetailsDefaultProps,
  StocksDetailsPropTypes,
} from './StocksDetails.proptypes';

const StocksDetails = ({ className, categoryLabel, stocks, unit }) => {
  const { t } = useTranslation();
  const { STOCKS_DETAILS_LIST_SORT } = SortOptions();

  const hasBatches = useMemo(() => {
    if (
      stocks.filter((stock) => stock.batches.find((batch) => batch)).length > 0
    ) {
      if (categoryLabel === 'ÉLECTRICITÉ') {
        return 'reel';
      }

      return 'bath';
    }

    return null;
  }, [categoryLabel, stocks]);

  return (
    <div
      className={cn('stocks-details', className, {
        [`stocks-details--${hasBatches}`]: hasBatches,
      })}
      data-qa-id="modal-stocks-details"
    >
      <p className="rs-modal-title">
        {t('common:entities:common.modal.stocks.title')}
      </p>
      {stocks.length > 0 ? (
        <>
          <ListSort
            className="stocks-details__list-sort"
            staticOptions={STOCKS_DETAILS_LIST_SORT}
          />
          <ul className="stocks-details__list" data-qa-id="stocks-details-list">
            {stocks.map((stock, index) =>
              stock.quantity ? (
                <li
                  className="stocks-details__item"
                  data-qa-id="stocks-details-item"
                  key={`stocks-details-item-${index}`}
                >
                  <Item
                    batches={stock.batches}
                    hasBatches={hasBatches}
                    quantity={stock.quantity}
                    stock={stock}
                    unit={unit}
                    warehouse={stock.warehouse}
                  />
                </li>
              ) : null,
            )}
          </ul>
        </>
      ) : (
        <div
          className="stocks-details__description"
          data-qa-id="stocks-details-description"
        >
          <p>{t('common:entities:common.modal.stocks.no_information')}</p>
        </div>
      )}
    </div>
  );
};

StocksDetails.defaultProps = {
  ...StocksDetailsDefaultProps,
};

StocksDetails.propTypes = {
  ...StocksDetailsPropTypes,
};

export default StocksDetails;
